import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import type CurrentAdminService from 'garaje/services/current-admin';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type StateService from 'garaje/services/state';
import { GLOBAL_ADMIN, LOCATION_ADMIN, RECEPTIONIST } from 'garaje/utils/roles';
import { Permission } from 'garaje/utils/ui-permissions';
import _intersection from 'lodash/intersection';

const CAN_REVIEW_ROLES = [GLOBAL_ADMIN, LOCATION_ADMIN, RECEPTIONIST];

export default class IdCheckAbility extends Ability {
  @service declare authz: AuthzService;
  @service declare currentAdmin: CurrentAdminService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare state: StateService;

  get canView(): boolean {
    if (!this.state.features?.canAccessIDCheck) return false;

    return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_FLOW_INSPECT);
  }

  get canReview(): boolean {
    if (!this.state.features?.canAccessIDCheck) return false;

    // Gate entry review on the granular ID scanning approval permission rather than admin roles.
    if (this.featureFlags.isEnabled('visitors-id-approval-permissions')) {
      return this.authz.hasPermissionAtCurrentLocation(Permission.VISITORS_ENTRY_ID_SCANNING_APPROVAL_REVIEW);
    }

    const { roleNames } = this.currentAdmin;

    return isPresent(_intersection(CAN_REVIEW_ROLES, roleNames));
  }
}
